import { Component, OnInit } from '@angular/core';
import { DatosMercado } from '../../../models/datos-mercado.model';
import { CatalogosService } from '../../../services/catalogos.service';

@Component({
  templateUrl: './lista-datos-mercado.component.html',
  styleUrls: ['./lista-datos-mercado.component.css'],
})

export class RecolecionDatosMercado implements OnInit {
  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio',
    },
    {
      label: 'Captura de Datos de Mercado',
      routerLink: '/datosmercado',
    },
  ];

  tipos: DatosMercado[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {}

  /*ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getDatosMercado().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }*/
  ngOnInit():void {
    this.loading = true;
    this.catalogosService.getDatosMercado().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        const descripcion = p.descripcion.toString();
        array.push(p);
      });
      this.tipos = array;
    });
  }
}
